import { observer } from 'mobx-react-lite';
import * as React from 'react';
import getDaysOfWeekAccordingToWeekStartDay from 'owa-recurrence-utils/lib/getDaysOfWeekAccordingToWeekStartDay';
import getRecurrenceDayAriaString from 'owa-recurrence-utils/lib/getRecurrenceDayAriaString';
import getRecurrenceDaySingleLetterString from 'owa-recurrence-utils/lib/getRecurrenceDaySingleLetterString';
import { CommandBarButton } from '@fluentui/react/lib/Button';
import { FocusZone, FocusZoneDirection } from '@fluentui/react/lib/FocusZone';
import { getButtonStyle, onDayButtonClicked } from '../utils/recurrenceDaysComponentUtils';
import { repeatDaysLabel } from './RecurrenceDaysComponent.locstring.json';
import loc from 'owa-localize';

let styles = require('./RecurrenceDaysComponent.scss');
let classNames = require('classnames/bind').bind(styles);

export interface RecurrenceDaysColor {
    checkedColor: string;
    checkedHoverColor: string;
}

export interface RecurrenceDaysProps extends React.HTMLProps<HTMLDivElement> {
    selectedDays: string[];
    colors: RecurrenceDaysColor;
    onDaySelectionChangedCallback: (selectedDays: string[]) => void;
}

export default observer(function RecurrenceDaysComponent(props: RecurrenceDaysProps) {
    const onDayClicked = (evt: React.MouseEvent<HTMLButtonElement>) => {
        onDayButtonClicked(
            evt.currentTarget.id,
            props.selectedDays,
            props.onDaySelectionChangedCallback
        );
    };
    let { selectedDays, className } = props;
    let customStyles = getButtonStyle(props.colors);
    let daysOfWeek = getDaysOfWeekAccordingToWeekStartDay();
    return (
        <FocusZone
            direction={FocusZoneDirection.horizontal}
            className={classNames(styles.buttonList, className)}
            role="listbox"
            aria-multiselectable="true"
            aria-label={loc(repeatDaysLabel)}>
            {daysOfWeek.map(day => (
                <CommandBarButton
                    id={day}
                    key={day}
                    role="option"
                    className={styles.dayButton}
                    styles={customStyles}
                    checked={selectedDays.includes(day)}
                    aria-selected={selectedDays.includes(day)}
                    onClick={onDayClicked}
                    ariaLabel={getRecurrenceDayAriaString(day)}
                    title={getRecurrenceDayAriaString(day)}>
                    {getRecurrenceDaySingleLetterString(day)}
                </CommandBarButton>
            ))}
        </FocusZone>
    );
});
